import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SwitchToggle from "../../components/SwitchToggle";

const SubadminList = () => {
  const navigate = useNavigate();

  const [rows] = useState([
    {
      id: 1,
      name: "David",
      email: "david@yopmail.com",
      phone: "9876543210",
      date: "01 March 2025",
      role: "Role 1",
      status: true
    },
    {
      id: 2,
      name: "David",
      email: "david@yopmail.com",
      phone: "9876543210",
      date: "01 March 2025",
      role: "Role 1",
      status: true
    },
    {
      id: 3,
      name: "David",
      email: "david@yopmail.com",
      phone: "9876543210",
      date: "01 March 2025",
      role: "Role 1",
      status: true
    }
  ]);

  const columns = [
    { id: 'name', label: 'Name' },
    { id: 'email', label: 'Email' },
    { id: 'phone', label: 'Phone Number' },
    { id: 'role', label: 'Role' },
    { id: 'date', label: 'Created Date' },
    { id: 'status', label: 'Status' },
    { id: 'action', label: 'Action' },
  ];

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow hover>
              {columns.map((column) => (
                <TableCell key={column.id}>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow hover key={row.id}>
                <TableCell>
                  <a
                    href="/manage-subadmin/detail"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/manage-subadmin/detail");
                    }}
                    className="user_block click_action"
                  >
                    <figure>
                      <img src="/static/images/user_placeholder.png" alt="User" />
                    </figure>
                    <p><b>{row.name}</b></p>
                  </a>

                </TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell>{row.phone}</TableCell>
                <TableCell>{row.role}</TableCell>
                <TableCell>{row.date}</TableCell>
                <TableCell>
                  <SwitchToggle />
                </TableCell>
                <TableCell>
                  <div className="table_actions v2">
                    <Box>
                      <IconButton onClick={() => navigate("/manage-subadmin/detail")}>
                        <img src="/static/images/eye_icon.svg" alt="" />
                      </IconButton>
                    </Box>
                    <Box>
                      <IconButton onClick={() => navigate("/manage-subadmin/add")}>
                        <img src="/static/images/edit2_icon.svg" alt="" />
                      </IconButton>
                    </Box>
                    <Box>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="" />
                      </IconButton>
                    </Box>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default SubadminList;